import React, { useEffect, useRef } from "react";

interface ImageProps {
  src: string;
  alt?: string;
  className?: string;
  onClick?: () => void;
  width?: number | string;
  height?: number | string;
  loading?: "lazy" | "eager";
  fetchPriority?: "high" | "low" | "auto";
  srcSet?: any;
}

// Some images might be above the fold, no need to lazy load them, in such cases,
// we can set loading="eager" or fetchPriority="high" to prioritize their loading.
const Image = ({
  src,
  alt = "",
  className,
  onClick,
  width,
  height,
  loading = "lazy",
  fetchPriority,
  srcSet
}: ImageProps) => {
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (imgRef.current) {
      if (width) {
        imgRef.current.style.setProperty("width", String(width), "important");
      }
      if (height) {
        imgRef.current.style.setProperty("height", String(height), "important");
      }
    }
  }, [width, height]);

  return (
    <img
      srcSet={srcSet}
      ref={imgRef}
      src={src}
      alt={alt}
      className={className}
      onClick={onClick}
      loading="lazy"
      width={width}
      height={height}
      style={{ cursor: onClick ? "pointer" : undefined }}
      decoding="async"
      {...(fetchPriority ? { fetchPriority } : {})}
    />
  );
};

export default Image;
